import React, { useEffect, useState } from "react";
import { Modal, Tab, Tabs, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getDdrmsRepositoryDocuments, loadDdrmsRepositoryDocs } from "../../store/ddrmsDocument";
import DataMapping from "./DataMapping";
import PurchaseOrderPopup from "../../../ReviewTools/PurchaseOrderPopup";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../store/candidate";

const GenerateContract = (props) => {
    const { showHide, uploadType, handleModalShowHide, workflowTask, app, applicantObj, viewType, prevItem } = props;

    const [repositoryDocs, setRepositoryDocs] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedKey, setSelectedKey] = useState("generate");
    const [poOrderType, setPoOrderType] = useState("add");
    const [purchaseShowHide, setPurchaseShowHide] = useState(false);
    const [candidateObj, setCandidateObj] = useState(null);
    const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
    const [wfTask, setWfTask] = useState(null);

    const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

    const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
    const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
    const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);

    const dispatch = useDispatch();

    useEffect(() => {
        console.log(workflowTask);
        if (workflowTask?.ciid > 0) {
            handleDocRefresh(workflowTask)
            setWfTask(workflowTask);
        } else if (applicantObj?.id) {

            if (prevItem?.applications?.length > 0)
                handleDocRefresh({ ciid: prevItem.applications[0].ciid })

            if (uploadType === "Subcontractor") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.subcontractor?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Recruiter") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.recruiter?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Candidate") {
                dispatch(loadCandidateWfTask(applicantObj?.id));
                setWfTaskReqCount(wfTaskReqCount + 1);
            }
        }
    }, []);

    useEffect(() => {
        console.log(subsCurrentWfTaskSelector)
        if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
            setWfTask(subsCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        }
        else if (subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.subcontractor?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(subsCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [subsCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(recCurrentWfTaskSelector)
        if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
            setWfTask(recCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        } else if (recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.recruiter?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(recCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [recCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(candidateCurrentWfTaskSelector)
        if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
            setWfTask(candidateCurrentWfTaskSelector)
            setWfTaskReqCount(0)
        } else if (candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            setWfTaskReqCount(wfTaskReqCount + 1)
            dispatch(candidateCurrentWfTaskReceived(null));
            dispatch(loadCandidateWfTask(applicantObj?.id));
        }
    }, [candidateCurrentWfTaskSelector]);

    useEffect(() => {
        if (ddrmsRepositoryDocumentsSelector.length > 0) {
            const filterDocx = ddrmsRepositoryDocumentsSelector.filter(x => x.fileExtension === "docx");
            setRepositoryDocs(filterDocx);
        }
        else {
            setRepositoryDocs([]);
        }
    }, [ddrmsRepositoryDocumentsSelector]);

    const handleDocRefresh = (wfTask) => {
        if (wfTask?.ciid > 0) {
            dispatch(loadDdrmsRepositoryDocs(wfTask.ciid));
            // if ((uploadType === "Recruiter" || uploadType === "Sub-Contractors") && viewType === "") {
            //     setSelectedKey("generate");
            // }
            // else {
            //     setSelectedKey("poOrder");
            // }
        }
    }


    const handleResetSelection = () => {
        setSelectedDocId(0);
        setSelectedDoc(null);
    }

    const handleSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
    };

    const handleCloseMapping = (type) => {
        setSelectedDocId(0);
        setSelectedDoc(null);
        //setSelectedKey("home");
        setTimeout(() => {
            handleModalShowHide(type)
        }, 3000);
    }

    const handleSelectedKey = (key) => {
        setSelectedKey(key)
    }

    const handlePurchaseShowHide = (item, type, poOrderType) => {
        // setSelectedDocId(0);
        // setSelectedDoc(null);
        // setPoOrderType(poOrderType);
        // setPurchaseShowHide(true);
        // if (item) {
        //     setSelectedItem(item);
        // }
    }
    const handleSignUnsignPo = (poOrder) => {
        // Logic to sign or unsign the purchase order
    }
    const handleRefreshPoOrders = () => {
        // Logic to refresh the purchase orders
        if (uploadType !== "Recruiter")
            handleModalShowHide("save");
    }

    return <>
        <Modal show={showHide} size="xl">
            <Modal.Header closeButton onHide={() => handleModalShowHide("")}>
                <Modal.Title>Generate Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    onSelect={handleSelectedKey}
                    activeKey={selectedKey}
                    defaultActiveKey={((uploadType === "Recruiter" || uploadType === "Sub-Contractors") && viewType === "") ? "generate" : "poOrder"}
                    id="uncontrolled-tab-example"
                    className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
                >
                    {viewType !== "candidateList" &&
                        <Tab eventKey="generate" title="Generate Documents" tabClassName="page-tab border border-left-0 border-top-0">
                            <Tab.Content className="border p-3 border-top-0">
                                {selectedDocId <= 0 && <>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-dark">Note : Only Supported Docx file</div>

                                        </div>
                                        <div className="col-md-6">
                                            <button className="btn btn-sm btn-link pl-0" onClick={handleResetSelection}>Reset Selection</button>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-sm btn-link pl-0" onClick={handleDocRefresh}>Refresh</button>
                                        </div>
                                    </div>
                                    <div className="table-responsive bg-white"
                                        style={{ maxHeight: "500px", overflow: "auto" }}>
                                        <table className="table align-items-center table-flush table-hover table-striped border">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Select</th>
                                                    <th>ID</th>
                                                    <th>Contract Template</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {repositoryDocs.length === 0 && <tr>
                                                    <td colSpan={3} align="center">Fetching DDRMS Document...</td>
                                                </tr>}
                                                {repositoryDocs.map((item) => (
                                                    <tr>
                                                        <td>
                                                            <div className="custom-control custom-radio">
                                                                <input
                                                                    className="custom-control-input"
                                                                    type="radio"
                                                                    id={item.id}
                                                                    name="role"
                                                                    onChange={() => handleSelection(item)}
                                                                    value={selectedDocId}
                                                                    checked={selectedDocId === item.id}
                                                                    disabled={item.fileExtension !== "docx"}
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor={item.id}
                                                                >
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>{item.id}</td>
                                                        <td>{item.name}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>}
                                {selectedDocId > 0 &&
                                    <DataMapping
                                        workflowTask={wfTask}
                                        app={app}
                                        uploadType={uploadType}
                                        selectedObj={selectedDoc}
                                        applicantObj={applicantObj}
                                        viewType={viewType}
                                        handleCloseMapping={handleCloseMapping} />
                                }
                            </Tab.Content>
                        </Tab>}
                    {viewType === "candidateList" &&
                        <Tab eventKey="poOrder" title="Generate/Upload Purchase Order" tabClassName="page-tab border border-left-0 border-right-0 border-top-0">
                            <Tab.Content className="border p-3 border-top-0">
                                {selectedKey === "poOrder" &&
                                    <PurchaseOrderPopup
                                        purchaseShowHide={true}
                                        handlePurchaseShowHide={handlePurchaseShowHide}
                                        candidateObj={applicantObj}
                                        workflowTask={wfTask}
                                        poOrderType={poOrderType}
                                        item={{ partnerType: uploadType === "Recruiter" ? "Recruiter" : "Sub-Contractors" }}
                                        handleSignUnsignPo={handleSignUnsignPo}
                                        handleRefreshPoOrders={handleRefreshPoOrders}
                                        renderType="generate"
                                    ></PurchaseOrderPopup>}
                            </Tab.Content>
                        </Tab>}
                </Tabs>
            </Modal.Body>
            {/* <Modal.Footer>
                <button className="btn btn-sm btn-outline-default" onClick={()=>handleModalShowHide("")}>
                    <i class="fa fa-times" aria-hidden="true"></i> Close
                </button>
            </Modal.Footer> */}
        </Modal>
    </>

}

export default GenerateContract;